import {LauncherServiceBase} from '../launcher-service-base';
import {ISearchResultItem} from './search-result/search-result-item.interface';
import {ISearchStrategy} from './search-strategies/search-strategy.interface';
import {action, computed, observable} from 'mobx';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {ConfigurationFieldSearchStrategy} from './search-strategies/configuration-field-search/configuration-field-search-strategy';
import {ILauncherSearchService} from './launcher-search.service.interface';
import {extractWordsRegularExpressions} from '../../../utils/string-helpers';
import {SdmGameSearchStrategy} from './search-strategies/sdm-game-search/sdm-game-search-strategy';
import {UriPath} from '../../../app-react/services/location/uri-path/uri-path';
import {buildLauncherPath, LAUNCHER_RELATIVE_PATHS} from '../routing/launcher-routing-configuration';

export class LauncherSearchService extends LauncherServiceBase implements ILauncherSearchService {

    constructor(services: ILauncherServiceFactory) {
        super(services);

        this.reaction(
            () => this.services.location.currentUri.pathName,
                currentPath => this._updateSearchStrategy(currentPath),
            {
                fireImmediately: true
            });


    }

    @observable.ref
    private _currentStrategy: ISearchStrategy;
    @action.bound
    private _setCurrentStrategy(strategy: ISearchStrategy): void {
        this._currentStrategy = strategy;
    }

    @observable.ref searchResult: ISearchResultItem[] = [];
    @action.bound
    private _setSearchResult(searchResult: ISearchResultItem[]): void {
        this.searchResult = searchResult;
    }

    @observable.ref isSearchInProgress = false;
    @action.bound
    private _setIsSearchInProgress(value: boolean): void {
        this.isSearchInProgress = value;
    }

    @observable.ref currentSearchText: string = '';
    @action.bound
    private _setCurrentSearchText(text: string): void {
        this.currentSearchText = text;
    }

    search(text: string): void {
        if(text && text.length > 2) {
            const words = extractWordsRegularExpressions(text);
            this._setSearchResult(this._currentStrategy.search(words));
            this._setIsSearchInProgress(true);
        } else {
            this._setSearchResult([]);
            this._setIsSearchInProgress(false);
        }

        this._setCurrentSearchText(text || '');
    }


    private _updateSearchStrategy(currentPath: UriPath) {
        this.clearSearch();
        if(currentPath.equals(buildLauncherPath(LAUNCHER_RELATIVE_PATHS.ADD_GAMES))) {
            this._setCurrentStrategy(new SdmGameSearchStrategy(this.services));
        }
        else {
            this._setCurrentStrategy(new ConfigurationFieldSearchStrategy(this.services));
        }
    }

    clearSearch(): void {
        this._setCurrentSearchText('');
        this._setIsSearchInProgress(false);
    }

    @computed get searchHintText(): string {
        return this._currentStrategy.searchHintText;
    }

    @computed get noMatchMessage(): string {
        return this._currentStrategy.noMatchMessage;
    }

}